import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const API_PREFIX = `${BASE_URL}/provider-payment/dpr/validation-support`;

export const getDprValidationSupportRecords = (params) =>
  axios.get(`${API_PREFIX}/records`, {
    params,
    headers: getAuthHeaders(),
  });

export const previewDprValidationSupportUpdate = (payload) =>
  axios.post(`${API_PREFIX}/preview`, payload, {
    headers: getAuthHeaders(),
  });

export const executeDprValidationSupportUpdate = (payload) =>
  axios.post(`${API_PREFIX}/bulk-update`, payload, {
    headers: getAuthHeaders(),
  });

export const getDprValidationSupportAuditLogs = (params) =>
  axios.get(`${API_PREFIX}/audit-logs`, {
    params,
    headers: getAuthHeaders(),
  });
